import { faker } from '@faker-js/faker';
import { useDailyReportsHeaderSectionQuery } from 'generated/graphql';

import { DashMetricTypes } from 'modules/components/layer05/DashboardMetric/DashboardMetric';
import React from 'react';

type DashboardMetricDataType = {
  id: string;
  metricType: DashMetricTypes;
  count: number;
  title: string;
};

export interface IData {
  unsubmitted: DashboardMetricDataType;
  inspections: DashboardMetricDataType;
  accidents: DashboardMetricDataType;
  deliveries: DashboardMetricDataType;
}

export function useQuery(id: string) {
  const tuple = useDailyReportsHeaderSectionQuery({
    variables: {
      options: {
        filter: {
          projectId: id
        }
      }
    },
    skip: id === ''
  });


  return React.useMemo(
    () => {

      const data: IData = {
        unsubmitted: __genDashboardMetric('unsubmittedDailyReports', tuple.data?.dailyReports?.reduce((acc, node) => {
          return acc += (node.numberOfWorkEvents ? node.numberOfWorkEvents : 0);
        }, 0)),
        inspections: __genDashboardMetric('inspections', tuple.data?.dailyReports?.reduce((acc, node) => {
          return acc += (node.numberOfInspections ? node.numberOfInspections : 0);
        }, 0)),
        accidents: __genDashboardMetric('accidents', tuple.data?.dailyReports?.reduce((acc, node) => {
          return acc += (node.numberOfIncidents ? node.numberOfIncidents : 0);
        }, 0)),
        deliveries: __genDashboardMetric('deliveries', tuple.data?.dailyReports?.reduce((acc, node) => {
          return acc += (node.numberOfDeliveries ? node.numberOfDeliveries : 0);
        }, 0))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]

  );
}

function __genDashboardMetric(metricType: DashMetricTypes, count: number | undefined): DashboardMetricDataType {
  return {
    id: faker.string.uuid(),
    metricType: metricType,
    count: count ?? 0,
    title: metricType
  };
}



